<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="bg_wrap">
      <topPiece></topPiece>
      <div class="container">
        <titleConfig
          :title="langSet == 'cn' ? '我的收藏' : 'My Collection'"
          :type="2"
        ></titleConfig>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :label="langSet == 'cn' ? '产品收藏' : 'Product'" name="product">
            <productList :productLists="list" :external="'product'" @item_click="item_click"></productList>
          </el-tab-pane>
          <el-tab-pane :label="langSet == 'cn' ? '展商收藏' : 'Exhibitor'" name="company">
            <companyList :companyLists="list" :external="'company'" @item_click="item_click"></companyList>
          </el-tab-pane>
          <el-tab-pane :label="langSet == 'cn' ? '商机收藏' : 'Business Opportunity'" name="business">
            <businessList :businessList="list" :external="'business'" @item_click="item_click"></businessList>
          </el-tab-pane>
        </el-tabs>
        <nodata v-if="list.length == 0"></nodata>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>


<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import titleConfig from "@/components/title.vue";
import topPiece from "@/components/topPiece.vue";
import productList from "../product/component/product_list.vue";
import companyList from "../company/component/company_list.vue";
import businessList from "../business/component/business_list.vue";
import nodata from "@/components/nodata.vue";
import { collectList } from "@/api/api";

export default {
  components: {
    top,
    bottom,
    topPiece,
    titleConfig,
    productList,
    companyList,
    businessList,
    nodata,
  },
  data() {
    return {
      langSet: "",
      activeName: "product",
      list: [],
    };
  },
  created() {},
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "cn";
    //25.6.17 获取产品收藏列表 dxm
    this.getCollect();
  },
  methods: {
    async getCollect() {
      let data = {
        type: this.activeName,
      };
      const res = await collectList(data);
      this.list = res.data.lists;
    },
    handleClick(tab) {
      this.activeName = tab.name;
      this.getCollect();
    },
    //跳转详情
    item_click(item,type){
      if(type=='product'){
        this.$router.push({
          path: "/product",
          query: {
            detail_show: true,
            product_long_id: item.product_long_id,
            exhibitor_long_id: item.exhibitor_long_id,
          },
        });
      }else if(type=='company'){
        this.$router.push({
          path: "/company",
          query: {
            detail_show: true,
            exhibitor_long_id: item.exhibitor_long_id,
          },
        });
      
    }else if(type=='business'){
        this.$router.push({
          path: "/business",
          query: {
            detail_show: true,
            id: item.dataid,
          },
        });

      }
    }
  },
};
</script>


<style scoped lang="scss">
.container{
  padding-bottom: 70px;
}
/deep/ .el-tabs__nav-wrap::after {
  display: none;
}
/deep/ .el-tabs__item {
  font-size: 30px;
  color: #888888;
  line-height: 61px;
  margin-top: 20px;
}
/deep/ .el-tabs__item {
  height: auto;
}
/deep/ .el-tabs__active-bar {
  height: 10px;
  width: 120px !important;
  bottom: 15px;
  background: rgba(230, 35, 68, 0.18);
}
/deep/ .el-tabs__item.is-active {
  color: #000;
}
@media only screen and (max-width: 767px) {
  /deep/ .el-tabs__item {
    font-size: 0.35rem;
    margin-top: 0.2rem;
    line-height: 0.69rem;
    padding: 0 10px;
  }
  /deep/ .el-tabs__active-bar {
    width: 1.38rem !important;
    height: 0.15rem;
    bottom: 9px;
  }
  /deep/ .el-tabs__nav-next,
  /deep/ .el-tabs__nav-prev {
    line-height: 57px;
  }
}
</style>